export default {
  computed: {
    importerTemplates() {
      return [
        {
          id: 'jira',
          alternativeName: 'Atlassian',
          boardEquivalent: 'boards',
          cardEquivalent: 'issues',
          inputs: ['accessToken', 'emailAddress', 'hostname'],
          accessTokenType: 'personal',
          accessTokenPlaceholder: 'xxxxxxxxxxxxxxxx',
          hostnamePlaceholder: 'yourcompany.atlassian.net',
          settingsUrl: 'https://id.atlassian.com/manage-profile/security/api-tokens',
          warningText: this.translate('notImportArchivedIssues'),
        },
        {
          id: 'trello',
          button: true,
          boardEquivalent: 'boards',
          cardEquivalent: 'cards',
        },
        {
          id: 'shortcut',
          boardEquivalent: 'teams',
          cardEquivalent: 'stories',
          inputs: ['accessToken'],
          accessTokenType: 'workspace',
          accessTokenPlaceholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
          settingsUrl: 'https://app.shortcut.com/settings/account/api-tokens',
          customOptions: [
            // {
            //   id: 'importOpenStories',
            //   label: this.translate('importOpenStories'),
            //   desc: this.translate('importOpenStoriesDesc'),
            // },
            // {
            //   id: 'importEpics',
            //   label: this.translate('importEpics'),
            //   desc: this.translate('importEpicsDesc'),
            // },
            // {
            //   id: 'importStaleStories',
            //   label: this.translate('importStaleStories'),
            //   desc: this.translate('importStaleStoriesDesc'),
            // },
          ],
        },
      ];
    },
    importer() {
      return this.importerTemplates.find((item) => item.id === this.$route.name);
    },
    importerName() {
      return this.$capitalizeFirstLetter(this.importer.id);
    },
    step() {
      return this.$store.getters.getImportProgressCurrentStep;
    },
    progressSteps() {
      return [
        {
          title: this.translate('connect'),
          desc: `${this.translate('connectToImporter', { importerName: this.importerName })}`,
        },
        {
          title: this.$capitalizeFirstLetter(this.importer.boardEquivalent),
          desc: this.translate(`selectBoardsToImport`, {
            boardEq: this.translate(this.importer.boardEquivalent).toLowerCase(),
            cardEq: this.translate(this.importer.cardEquivalent),
          }),
        },
        {
          title: this.translate('users'),
          desc: this.translate('selectUsersImport'),
        },
        {
          title: this.translate('finish'),
        },
      ];
    },
  },
  methods: {
    connectToJira() {
      const jiraCred = {
        source: 'jira',
        jira_credentials: {
          pac: this.$refs.importConnect.accessToken,
          email: this.$refs.importConnect.emailAddress,
          hostname: this.$refs.importConnect.hostname,
        },
      };
      this.setUpImport(jiraCred);
    },
    connectToTrello() {
      const token = this.$route.hash.split('=')[1];
      const trelloCred = {
        source: 'trello',
        trello_credentials: {
          api_key: process.env.VUE_APP_TRELLO_API_KEY,
          token,
        },
      };
      this.setUpImport(trelloCred);
    },
    connectToShortcut() {
      const api_token = this.$refs.importConnect.accessToken;
      const shortcutCred = {
        source: 'shortcut',
        shortcut_credentials: {
          api_token,
        },
      };
      this.setUpImport(shortcutCred);
    },
  },
};
